/**
 * Helper function to safely set a deeply nested property (one level deep) without overwriting the entire app state
 * @param name The name of the state property to set
 * @param value The value to set
 * @returns
 */
// TODO: maybe use Immer for this (https://github.com/immerjs/immer)
export function deepSet(name, value) {
    return (state) => ({ ...state, [name]: { ...state[name], ...value } });
}
